@if (isRecording()) {
<div class="meo-audio-overlay">
  <!-- Cancel — small icon, top-right corner -->
  <button class="cancel-btn" (click)="cancelRecording()"
    [attr.aria-label]="cancelLabel">
    <app-svg name="close" height="18" width="18" [color]="ss.theme().color8"></app-svg>
  </button>

  <!-- State label -->
  <div class="recording-state-label">
    {{ isProcessing() ? processingText : listeningText }}
  </div>

  <!-- Reactive waveform -->
  <div class="waveform-container">
    <div class="waveform-fade waveform-fade-start"></div>
    <div class="waveform-bars">
      @for (i of waveformBarSlots; track $index) {
        <div class="waveform-bar"></div>
      }
    </div>
    <div class="waveform-fade waveform-fade-end"></div>
  </div>

  <!-- Timer -->
  <div class="recording-timer">
    {{ formattedTime }} / {{ maxTimeFormatted }}
  </div>

  <!-- Send — single prominent action -->
  <button class="send-btn" (click)="stopRecording()"
    [attr.aria-label]="sendLabel">
    <app-svg name="send" height="22" width="22" [color]="ss.theme().color12"></app-svg>
  </button>
</div>
}
